import React from 'react';

import { FieldElementPropTypes } from '../propTypes';
import RemoveButton from 'core/components/remove-button';

const RemoveField = ({ field: props }) => {
  return <RemoveButton {...props} />;
};
RemoveField.propTypes = FieldElementPropTypes;

export default RemoveField;
